import React, { useEffect } from 'react'
import ModalDetailComponent from '../components/ModalDetailComponent'
import { useDispatch, useSelector } from 'react-redux';
import { openDetail } from '../redux/slice/userDetailSlice';

const FormDetailUser = ({ param }) => {
    const dispatch = useDispatch();
    // const { dataByIdUser, isOpenDetailUser, isLoading } = useSelector( (state) => state.user );
    const { idUserDetail, dataByIdUserDetail, isOpenForm, isOpenDetailUser, state } = useSelector( (state) => state.userDetail);
    // console.log(id)

  return (
    <ModalDetailComponent
      title="DETAIL DATA USER"
      show={isOpenDetailUser}
      close={() => dispatch(openDetail({ open: false, type: 'close' }))}
      idForm="detailUser-form"
    >
        <div className="row" style={{ alignItems: 'center'}}>
            <div className="col-xl-6">
                <table className="table">
                    {/* <thead>
                        <tr>
                            <span> Detail Data Kamera </span>
                         </tr>
                    </thead> */}
                    <tbody>
                        <tr> Nama Pengguna : {dataByIdUserDetail.username} </tr>
                        <tr> Nama Peran :  {dataByIdUserDetail.rolesName} </tr>
                        <tr> Nama Depan : {dataByIdUserDetail.firstName} </tr>
                        <tr> Nama Belakang : {dataByIdUserDetail.lastName} </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-xl-6">
                <tbody>
                    <tr> Nomor Telephone : {dataByIdUserDetail.phone} </tr>
                    <tr> Alamat Pengguna :  {dataByIdUserDetail.address} </tr>
                    <tr> Lokasi JPO : {dataByIdUserDetail.sitesId} </tr>
                </tbody>
            </div>
        </div>
    </ModalDetailComponent>
  )
}

export default FormDetailUser